import React, { useContext } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, AuthContext } from './context/AuthContext';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import CreateCase from './pages/CreateCase';
import CaseDetail from './pages/CaseDetail';
import CasesList from './pages/CasesList';
import Settings from './pages/Settings';
import CaseAgentWidget from './pages/CaseAgentWidget';
import AiRequestPreview from './pages/AiRequestPreview';
import HumanVerificationWorkbench from './pages/HumanVerificationWorkbench';
import AppLayout from './components/AppLayout';


function ProtectedRoute({ children }) {
  const { token, user } = useContext(AuthContext);
  return token && user ? <AppLayout>{children}</AppLayout> : <Navigate to="/login" />;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/case-agent" element={<CaseAgentWidget />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/create-case"
            element={
              <ProtectedRoute>
                <CreateCase />
              </ProtectedRoute>
            }
          />
          <Route
            path="/cases"
            element={
              <ProtectedRoute>
                <CasesList />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings"
            element={
              <ProtectedRoute>
                <Settings />
              </ProtectedRoute>
            }
          />
          <Route
            path="/case/:id"
            element={
              <ProtectedRoute>
                <CaseDetail />
              </ProtectedRoute>
            }
          />
          <Route
            path="/case/:id/ai-request-preview"
            element={
              <ProtectedRoute>
                <AiRequestPreview />
              </ProtectedRoute>
            }
          />
          <Route path="/human-verification" element={<ProtectedRoute><HumanVerificationWorkbench /></ProtectedRoute>} />
          <Route path="/" element={<Navigate to="/dashboard" />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
